import { Outlet, createFileRoute } from '@tanstack/react-router';

import { SettingsPageLayout } from '@/components/Settings/SettingsPageLayout';

export const Route = createFileRoute('/$organizationName/cb/$codebaseId/settings')({
  component: CodebaseSettingsLayout,
});

function CodebaseSettingsLayout() {
  return (
    <SettingsPageLayout hideSeparator>
      <Outlet />
    </SettingsPageLayout>
  );
}
